@if (T$ | async; as T) {
  @let isClose = menuToggleService.isClose$ | async;
  @if (grants) {
    <!-- Spaziature: gap-2 fra elementi dello stesso blocco, gap-4 fra blocchi.
         Nessun margine sui singoli elementi. -->
    <div class="flex h-16 flex-row flex-nowrap items-center justify-between gap-4 bg-surface-200 px-4 py-2">
      <div class="flex flex-row flex-nowrap items-center gap-2">
        <!-- <p-tieredMenu #headermenu [popup]="true" [model]="menuItems" [appendTo]="'body'"></p-tieredMenu> -->
        <!-- <button type="button" pButton icon="fa-solid fa-bars text-xl" class="p-button-text text-primary md:hidden"
      [title]="T | translateItem: 'generic.menu'" (click)="toggleandLoadMenu($event,headermenu)"></button> -->
        <!-- In mobile il contenitore di sezione non ha piu' spazio per il suo bottone hamburger:
             passa qui, pilotato via MenuToggleService (home-inner.component resta il proprietario
             dello stato del menu). -->
        @if (layoutService.isNarrowScreen$ | async) {
          <i
            [ngClass]="{
              'fa-xmark': isClose,
              'fa-bars': !isClose
            }"
            style="width: 1.25rem"
            class="fa-solid my-auto cursor-pointer text-xl text-primary"
            [title]="T | translateItem: 'generic.menu'"
            (click)="menuToggleService.requestToggle()"></i>
        }

        <!-- Logo, nome e ambiente DB: lo stesso blocco che usa l'intestazione del menu
             laterale. Ancora, non img+(click): ctrl/cmd+click e rotellina aprono la
             home in una nuova tab senza codice, e l'href rispetta il base href. -->
        <app-brand [linkTitle]="T | translateItem: 'menu.Home'" />
      </div>

      <!-- Le soglie del layout compatto stanno in LayoutService: isHeaderCompact
           scatta prima se la barra ospita la ricerca impersonamento. -->
      <div class="flex h-16 flex-row flex-nowrap items-center justify-end gap-4" [class.grow]="!isHeaderCompact">
        <!-- Impersonamento: solo layout esteso -->
        @if (!isHeaderCompact && (possoImpersonare || stoImpersonando)) {
          <div class="flex grow flex-row flex-nowrap items-center justify-end gap-2">
            <!-- max-w-lg = 32rem: il campo cresce fino a quel limite e resta
               ancorato a destra, lo spazio libero si accumula a sinistra. -->
            <div class="max-w-lg grow">
              <ng-container *ngTemplateOutlet="autocomplete_search_user" />
            </div>
            @if (stoImpersonando) {
              <button
                type="button"
                pButton
                class="p-button-text danger text-surface-600"
                (click)="endImpersona()"
                icon="fa-solid fa-user-slash text-xl"
                [title]="T | translateItem: 'generic.impersona.end'"></button>
            }
          </div>
        }

        @if (!appInitialized.dtoUtente.utente?.flHoRilasciDaAccettare) {
          <div class="flex flex-row flex-nowrap items-center gap-2">
            <button
              *grantVisible="grants | async; key: 'profiloutente'"
              type="button"
              pButton
              class="p-button-text text-surface-600"
              (click)="navigateToProfiloUtente()"
              icon="fa-solid fa-user-gear text-xl"
              [title]="T | translateItem: 'menu.profiloUtente.title'"></button>

            <button
              type="button"
              pButton
              class="p-button-text p-button-icon-only notifications-button"
              [title]="T | translateItem: 'generic.notifications'"
              (click)="notificationsEvent($event)">
              <span
                pBadge
                class="fa-solid fa-bell text-xl text-surface-600"
                severity="danger"
                [badgeDisabled]="!notificationNotReadCount"
                [value]="notificationNotReadCount | badgeCount"></span>
            </button>
          </div>
        }

        <!-- Solo layout esteso -->
        @if (!isHeaderCompact) {
          <div class="flex flex-row flex-nowrap items-center gap-2">
            <p-chip
              [label]="appInitialized.dtoUtente.utente.email"
              icon="fa-solid fa-user text-surface-600"
              pTooltip="{{
                appInitialized.dtoUtente.utente.nome
                  ? appInitialized.dtoUtente.utente.nome + ' ' + appInitialized.dtoUtente.utente.cognome
                  : ''
              }}"
              tooltipPosition="bottom" />

            <div>
              @if (userProfiles.length > 1) {
                <p-dropdown
                  [options]="userProfiles"
                  optionLabel="des"
                  optionValue="id"
                  styleClass="p-inputtext-sm"
                  appendTo="body"
                  [emptyMessage]="T | translateItem: 'generic.dropdownEmpty'"
                  (onChange)="onProfileChange($event)" />
              }

              @if (userProfiles.length === 1) {
                <span>{{ currentProfile.des }}</span>
              }
            </div>

            <button
              type="button"
              pButton
              class="p-button-text text-xl text-surface-600"
              (click)="logout()"
              icon="fa-solid fa-arrow-right-from-bracket text-xl"
              [title]="T | translateItem: 'generic.logout'"></button>
          </div>
        }
        <!-- END - solo layout esteso -->

        <!-- Solo layout compatto -->
        <!-- Il pannello sta dentro il blocco del suo pulsante: il suo host e' un
             flex item a larghezza zero e in un contenitore con gap
             genererebbe uno spazio fantasma. -->
        @if (isHeaderCompact) {
          <div class="flex flex-row flex-nowrap items-center">
            <p-overlayPanel #headerusermenu>
              <ng-template pTemplate>
                <p-chip
                  [label]="appInitialized.dtoUtente.utente.email"
                  icon="fa-solid fa-user"
                  pTooltip="{{
                    appInitialized.dtoUtente.utente.nome
                      ? appInitialized.dtoUtente.utente.nome + ' ' + appInitialized.dtoUtente.utente.cognome
                      : ''
                  }}"
                  tooltipPosition="bottom" />

                <div class="p-fluid mt-4">
                  @if (userProfiles.length > 1) {
                    <p-dropdown
                      [options]="userProfiles"
                      optionLabel="des"
                      optionValue="id"
                      styleClass="p-inputtext-sm"
                      appendTo="body"
                      [emptyMessage]="T | translateItem: 'generic.dropdownEmpty'"
                      (onChange)="onProfileChange($event)" />
                  }
                </div>

                @if (userProfiles.length === 1) {
                  <p class="text-center">
                    {{ currentProfile.des }}
                  </p>
                }

                <p-divider />

                @if (possoImpersonare || stoImpersonando) {
                  <div class="font-semibold text-primary">
                    {{ T | translateItem: 'generic.impersonamento' }}
                  </div>

                  <div class="p-fluid my-4">
                    <ng-container *ngTemplateOutlet="autocomplete_search_user" />
                  </div>
                  @if (stoImpersonando) {
                    <button
                      type="button"
                      pButton
                      class="p-button-danger"
                      (click)="endImpersona()"
                      icon="fa-solid fa-user-slash"
                      [title]="T | translateItem: 'generic.impersona.end'"
                      [label]="T | translateItem: 'generic.impersona.end'"></button>
                  }

                  <p-divider />
                }

                <button
                  type="button"
                  pButton
                  class="p-button-text p-button-danger"
                  (click)="logout()"
                  icon="fa-solid fa-arrow-right-from-bracket text-xl"
                  [label]="T | translateItem: 'generic.logout'"
                  [title]="T | translateItem: 'generic.logout'"></button>
              </ng-template>
            </p-overlayPanel>

            <button
              type="button"
              pButton
              class="p-button-text text-surface-600"
              (click)="headerusermenu.toggle($event)"
              icon="fa-solid fa-user text-xl"
              [title]="T | translateItem: 'generic.userSettings'"></button>
          </div>
        }
        <!-- END - solo layout compatto -->
        <ng-template #autocomplete_search_user>
          @if (possoImpersonare && !stoImpersonando) {
            <p-autoComplete
              [suggestions]="usersArray"
              (completeMethod)="searchUsers($event)"
              appendTo="body"
              [minLength]="3"
              [dataKey]="'guid'"
              [optionLabel]="'autoCompleteDes'"
              (onSelect)="impersona($event)"
              inputStyleClass="p-inputtext-sm w-full"
              styleClass="w-full"
              [forceSelection]="true"
              [showEmptyMessage]="true"
              [emptyMessage]="T | translateItem: 'generic.autocompleteEmpty'"
              [placeholder]="T | translateItem: 'generic.autocompleteImpersona'">
              <ng-template let-user pTemplate="item">
                <div>
                  {{ user.autoCompleteDes }}
                </div>
              </ng-template>
            </p-autoComplete>
          }
        </ng-template>
      </div>
    </div>
  }
}
